export class ControlFailureCount {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "controlId",
            "baseName": "controlId",
            "type": "string",
            "format": ""
        },
        {
            "name": "controlName",
            "baseName": "controlName",
            "type": "string",
            "format": ""
        },
        {
            "name": "affectedResources",
            "baseName": "affectedResources",
            "type": "number",
            "format": "int32"
        }
    ];
    static getAttributeTypeMap() {
        return ControlFailureCount.attributeTypeMap;
    }
    constructor() {
    }
}
